import ApiCall from "../../../utils/apiCall";
import { showModal } from "../../../actions/ui";

const initialState = {
  isFetching: false,
  allOffers: []
};

// Reducer
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case "store.offers.isFetching":
      return { ...state, isFetching: true };

    case "store.offers.fetchSuccess":
      return { ...state, isFetching: false, store: action.response };

    case "store.offers.allOffers.fetchSuccess":
      return { ...state, isFetching: false, allOffers: action.response };

    case "store.offers.fetchError":
      return { ...state, isFetching: false };

    default:
      return state;
  }
}

// Actions
export function getAllOffers() {
  return async dispatch => {
    dispatch({ type: "store.offers.isFetching" });
    try {
      const response = await ApiCall.get(`/stores/offers`);
      dispatch({
        type: "store.offers.allOffers.fetchSuccess",
        response: response.json
      });
    } catch (error) {
      dispatch({ type: "store.offers.fetchError" });
    }
  };
}

export function createOffer({ offerType, resourceType, resourceId }) {
  return async dispatch => {
    dispatch({ type: "store.offers.isFetching" });
    try {
      const response = await ApiCall.post("/stores/offers", {
        offer_type: offerType,
        resource_type: resourceType || "",
        resource_id: resourceId || ""
      });

      if (offerType === "churn_2_month_free") {
        dispatch(showModal("FREE_TRIAL_OFFER_SUCCESS_MODAL"));
      } else if (offerType === "fifty_off_3_months") {
        dispatch(showModal("FIFTY_OFF_3_MONTHS_OFFER_SUCCESS_MODAL"));
      } else if (offerType === "two_week_trial") {
        dispatch(getAllOffers());
      }
      dispatch({
        type: "store.offers.fetchSuccess",
        response: response.json
      });
    } catch (error) {
      dispatch({ type: "store.offers.fetchError" });
    }
  };
}



// WEBPACK FOOTER //
// ./src/newDropshipperApp/module/store/offers.js